import React from 'react';
import styled from 'styled-components';

import media from '../../../utils/mediaQueries';
import { NOTES_COLOR } from '../../../theme';

const Header = styled.div`
  padding: 32px 40px 24px;
  border-bottom: 1px solid #eef1f6;
  
  ${media.mobile`
    padding: 16px 8px 16px 24px;
  `}
`;

const TopRow = styled.div`
  display: flex;
`;

const Title = styled.h1`
  font-size: 32px;
  padding-bottom: 16px;
  letter-spacing: 0.2px;
  font-weight: 800;
  margin: 0;
  flex: 1;
  
  ${media.mobile`
    font-size: 18px;
    line-height: 1.44;
    padding-bottom: 8px;
  `}
`;

const Logo = styled.div`
  width: 96px;
  margin-left: 32px;
  display: flex;
  align-items: center;

  ${media.mobile`
    width: 48px;
    margin-left: 8px;
    align-items: flex-start;
  `}

  img {
    width: 100%;
    height: auto;
  }
`;

const Address = styled.div`
  font-size: 14px;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: ${NOTES_COLOR};
`;

type CommonHeaderProps = {
  examCenterTitle: string,
  examCenterLogo: string,
  examCenterAddress: string
};

const CommonHeader = ({ examCenterTitle, examCenterLogo, examCenterAddress }: CommonHeaderProps) => (
  <Header>
    <TopRow>
      <Title>{examCenterTitle}</Title>
      <Logo><img src={examCenterLogo} alt="logo" /></Logo>
    </TopRow>
    <Address>{examCenterAddress}</Address>
  </Header>
);

export { CommonHeader };
